import { useMemo, useState } from "react"

import { APIS } from "../../../../config/apis"
import { ALERT_TYPE, FIRMA_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { standardRequest } from "../../../../utils/requests"
import { MEMO_FIRMA_LISTAS } from "../consts"

import { FormError, Modal, FormLabel, Select } from "../../../common"
import { useFormErrors, useLista, useManagedContext, useNav, } from "../../../hooks"
import { VALIDATION_MESSAGE } from "../../../../consts/validationMessage"

const SelectTipoFirmaModal = ({ idCuenta, idTributo, selectableIds, onCertificadoAdded, close }) => {
    const { setIsLoading } = useManagedContext()

    const [idTipoFirma, setIdTipoFirma] = useState(0)

    const [, getRowLista] = useLista({
        listas: ["TipoFirma", "EstadoFirma"],
        onLoaded: (listas, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
          key: MEMO_FIRMA_LISTAS,
          timeout: 0
        }
    });

    const { errorOf, validate } = useFormErrors(getErrors)

    function getErrors() {
        const errors = {}

        if (idTipoFirma === 0) errors.idTipoFirma = VALIDATION_MESSAGE.REQUIRED_OPTION

        return errors
    }

    const onClickAccept = () => {
        if (!validate()) return

        const idEntidad = Number(idTipoFirma) === FIRMA_TYPE.CERTIFICADO_LIBRE_DEUDA ? idCuenta : idTributo

        setIsLoading(true)
        standardRequest(REQUEST_METHOD.PUT, `${APIS.URLS.FIRMA_DIGITAL}/tipo-firma/${idTipoFirma}`, { idEntidad })
        .then(data => {
            onCertificadoAdded()
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Solicitud de firma digital enviada correctamente")
        })
        .catch(error => {})
        .finally(() => setIsLoading(false))
    }

    const onClickCancel = () => {
        close()
    }

    const getNameFromId = id => getRowLista("TipoFirma", id)?.nombre ?? ''

    return (
        <Modal
            onEscape={onClickCancel}
            show
            title="Seleccionar tipo de firma"
            body={(
                <div className='row form-basic'>
                    <div className="col-12">
                        <FormLabel htmlFor="idTipoFirma" required>Tipo de firma</FormLabel>
                        <Select
                            name="idTipoFirma"
                            className={`form-control ${errorOf('idTipoFirma') ? 'is-invalid' : ''}`}
                            value={idTipoFirma}
                            onChange={({ target }) => setIdTipoFirma(target.value)}
                            options={selectableIds.map(id => ({ value: id, label: getNameFromId(id) }))}
                        />
                        <FormError message={errorOf('idTipoFirma')} />
                    </div>
                </div>
            )}
            footer={<>
                <button className="btn btn-outline-primary" data-dismiss="modal" onClick={onClickCancel}>
                    Cancelar
                </button>
                <button className="btn btn-primary" data-dismiss="modal" onClick={onClickAccept}>
                    Aceptar
                </button>
            </>}
        />
    )
}

export default SelectTipoFirmaModal
